import 'twin.macro';

import { Card, Image, Stack, Text } from '@cheqroom/ui';
import { FC } from 'react';

import itemPreviewLogo from '../../../../public/assets/images/item-preview.png';
import { CustomField, SystemField, SystemFieldType } from '../../../hooks/item-fields/types';
import { ItemInfo } from '../../Info/ItemInfo/ItemInfo';
import getDefaultValueForItemField from '../helpers/get-default-value-for-item-field';
import { CardTag } from './ItemPreview.styles';
import { usePreviewFields } from './use-preview-fields';

type Props = {
	viewType: 'table' | 'cards' | 'scheduler';
	fieldIds: string[];
	getFieldById: (fieldId: string) => SystemField<SystemFieldType> | CustomField | undefined;
};

const RowPreview: FC<Omit<Props, 'viewType'>> = ({ fieldIds, getFieldById }) => {
	const fields = usePreviewFields(fieldIds, getFieldById, getDefaultValueForItemField);

	return (
		<Stack vertical tw="w-full">
			<CardTag size="small">Preview</CardTag>
			<Card tw="px-4 py-3 relative">
				<Stack spacing="tight" tw="overflow-hidden">
					<Image
						// TODO localise this alt text
						alt="item preview"
						fit="contain"
						src={itemPreviewLogo}
						tw="h-[40px] w-[40px]"
					/>
					<Stack vertical tw="overflow-hidden">
						<Text weight="bold">GoPro Hero 10 Black</Text>
						<ItemInfo extraFields={fields} />
					</Stack>
				</Stack>
			</Card>
		</Stack>
	);
};

const CardPreview: FC<Omit<Props, 'viewType'>> = ({ fieldIds, getFieldById }) => {
	const fields = usePreviewFields(fieldIds, getFieldById, getDefaultValueForItemField);

	return (
		<Stack vertical tw="w-80">
			<CardTag size="small">Preview</CardTag>
			<Card tw="relative">
				<Image src={itemPreviewLogo} alt="Item preview image" tw="h-52 mt-6" fit="contain" />
				<Card.Footer>
					<Stack vertical spacing="tight">
						<Text weight="bold">GoPro Hero 10 Black</Text>
						<ItemInfo extraFields={fields} />
					</Stack>
				</Card.Footer>
			</Card>
		</Stack>
	);
};

const ItemPreview: FC<Props> = ({ viewType, ...props }) => {
	switch (viewType) {
		case 'scheduler':
		case 'table':
			return <RowPreview {...props} />;
		case 'cards':
			return <CardPreview {...props} />;
		default:
			return null;
	}
};

export default ItemPreview;
